import { typedStyles } from '@/utils/styleUtils';

import { colors } from '@/themesConfig/colors';

export const styles = typedStyles({
  modal: {
    display: 'flex',
    width: 'min(640px, 92%)',
    maxHeight: 'min(90vh, 900px)',
    padding: '40px 40px 32px',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: 0,
    borderRadius: '24px',
    boxSizing: 'border-box',
    overflow: 'hidden',
  },

  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: 0,
    flex: 1,
    gap: 4,
  },

  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 1,
    width: '100%',
    pr: 5,
    flexShrink: 0,
  },

  title: {
    fontWeight: 700,
    fontSize: 24,
    lineHeight: '32px',
    color: colors.brandBlack,
  },

  description: {
    color: colors.darkerGrey,
    fontFamily: 'Metropolis, sans-serif',
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
  },

  body: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: 3,
    width: '100%',
    minHeight: 0,
    overflowY: 'auto',
    pr: 0.5,
  },

  fieldRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    columnGap: 3,
    rowGap: 0,
    width: '100%',
    alignItems: 'start',
  },

  field: {
    width: '100%',
    minWidth: 0,
    '& .MuiFormControl-root': {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    '& .MuiInputLabel-root': {
      position: 'relative',
      transform: 'none',
      fontSize: 12,
      lineHeight: '16px',
      color: colors.darkGrey,
      marginBottom: 1,
    },
    '& .MuiInput-root': {
      marginTop: 0,
    },
    '& .MuiFormHelperText-root': {
      marginTop: 0.5,
      minHeight: 0,
    },
  },

  fieldFull: {
    width: '100%',
  },

  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    alignSelf: 'stretch',
    gap: 2,
    flexShrink: 0,
    pt: 1,
  },

  cancelButton: {
    minWidth: 112,
    height: 44,
    px: 3,
    borderRadius: '22px',
    borderWidth: 1,
    borderColor: colors.brandBlack,
    color: colors.brandBlack,
    fontWeight: 600,
    fontSize: 14,
    textTransform: 'none',
    boxShadow: 'none',
    '&:hover': {
      borderWidth: 1,
      borderColor: colors.brandBlack,
      backgroundColor: colors.lighterGrey,
    },
  },

  submitButton: {
    minWidth: 112,
    height: 44,
    px: 3,
    borderRadius: '22px',
    backgroundColor: `${colors.brandBlack} !important`,
    color: `${colors.white} !important`,
    fontWeight: 600,
    fontSize: 14,
    textTransform: 'none',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: `${colors.almostBlack} !important`,
      boxShadow: 'none',
    },
    '&.Mui-disabled': {
      backgroundColor: `${colors.lightGrey} !important`,
      color: `${colors.darkGrey} !important`,
      opacity: 1,
    },
  },
});
